import { ReactComponent as JioSaavnColorLight } from 'fym-shared/src/music-services/assets/images/jiosaavn-color-light.svg';
import { ReactComponent as JioSaavnColorDark } from 'fym-shared/src/music-services/assets/images/jiosaavn-color-dark.svg';
import { ReactComponent as JioSaavnColorLightPadding } from 'fym-shared/src/music-services/assets/images/jiosaavn-color-light-padding.svg';
import { ReactComponent as JioSaavnColorDarkPadding } from 'fym-shared/src/music-services/assets/images/jiosaavn-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const jioSaavnImages: MusicServiceImages = {
  logoColor: {
    light: JioSaavnColorLight,
    dark: JioSaavnColorDark,
  },
  logoColorPadding: {
    light: JioSaavnColorLightPadding,
    dark: JioSaavnColorDarkPadding,
  },
};
